export default __webpack_public_path__ + "static/media/ic-tool.688f8d26.png";